import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=fa5fc938&scoped=true"
import script from "./NotificationSetting.vue?vue&type=script&lang=js"
export * from "./NotificationSetting.vue?vue&type=script&lang=js"
import style0 from "./NotificationSetting.vue?vue&type=style&index=0&id=fa5fc938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5fc938",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VBtnToggle,VCheckbox,VIcon,VProgressCircular})
